import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React from 'react';
import { CircleCheck, CircleAlert, TriangleAlert } from 'lucide-react';
import { Vehicle } from 'components/Erp/Display';
import styles from '../ReportCard.module.scss';

/**
 * Три модальных окна статуса: Success / Error / Warning.
 */
const StatusModals = ({
  showSuccessModal, successModalData, onCloseSuccess,
  showErrorModal, errorModalData, onCloseError,
  showWarningModal, warningModalData, onCloseWarning,
}) => {
  useInterfaceLanguage();
  return (
    <>
      {/* Успех */}
      {tr(showSuccessModal && successModalData && (
        <div className={styles.successModalOverlay}>
          <div className={styles.successModalContent} role="dialog" aria-modal="true" aria-label={tr("Результат операции")}>
            <div className={styles.successModalHeader}>
              <div className={styles.successIcon}><CircleCheck size={28} /></div>
              <h2 className={styles.successTitle}>
                {successModalData.actionType === 'guard_exit'
                  ? tr("Выезд с базы подтверждён — Водитель в пути")
                  : successModalData.actionType === 'exit'
                  ? tr("Погрузка успешно завершена и принята")
                  : tr("Успешно подтверждён въезд в базу")}
              </h2>
            </div>
            <div className={styles.successModalBody}>
              <ModalDataRow label={tr("ФИО")} value={successModalData.fio} prefix="success" />
              <ModalDataRow label={tr("Телефон")} value={successModalData.phone} prefix="success" />
              <ModalDataRow label={tr("Авто номер")} value={<Vehicle number={successModalData.vehicleNumber} />} prefix="success" />
              <ModalDataRow label={tr("База")} value={successModalData.base} prefix="success" />
            </div>
            <div className={styles.successModalFooter}>
              <button onClick={onCloseSuccess} className={styles.successCloseBtn}>{tr("Продолжить")}</button>
            </div>
          </div>
        </div>
      ))}

      {/* Ошибка */}
      {tr(showErrorModal && errorModalData && (
        <div className={styles.errorModalOverlay}>
          <div className={styles.errorModalContent} role="dialog" aria-modal="true" aria-label={tr("Результат операции")}>
            <div className={styles.errorModalHeader}>
              <div className={styles.errorIcon}><CircleAlert size={28} /></div>
              <h2 className={styles.errorTitle}>{tr(errorModalData.reason)}</h2>
            </div>
            <div className={styles.errorModalBody}>
              <ModalDataRow label={tr("ФИО")} value={errorModalData.fio} prefix="error" />
              <ModalDataRow label={tr("Телефон")} value={errorModalData.phone} prefix="error" />
              <ModalDataRow label={tr("Авто номер")} value={<Vehicle number={errorModalData.vehicleNumber} />} prefix="error" />
              <ModalDataRow label={tr("База")} value={errorModalData.base} prefix="error" />
              <div className={styles.errorMessage}>{tr("СООБЩИТЕ АДМИНИСТРАЦИИ О НАРУШЕНИИ")}<br />
                <strong>0600011032</strong>
              </div>
            </div>
            <div className={styles.errorModalFooter}>
              <button onClick={onCloseError} className={styles.errorCloseBtn}>{tr("Закрыть")}</button>
            </div>
          </div>
        </div>
      ))}

      {/* Предупреждение */}
      {tr(showWarningModal && warningModalData && (
        <div className={styles.warningModalOverlay}>
          <div className={styles.warningModalContent} role="dialog" aria-modal="true" aria-label={tr("Результат операции")}>
            <div className={styles.warningModalHeader}>
              <div className={styles.warningIcon}><TriangleAlert size={28} /></div>
              <h2 className={styles.warningTitle}>{tr(warningModalData.title)}</h2>
            </div>
            <div className={styles.warningModalBody}>
              <p className={styles.warningText}>{tr(warningModalData.message)}</p>
              <p className={styles.warningSubtext}>
                <strong>{tr("База:")}</strong> {tr(warningModalData.distance)}
              </p>
              <p className={styles.warningSubtext}>{tr(warningModalData.requirement)}</p>
            </div>
            <div className={styles.warningModalFooter}>
              <button onClick={onCloseWarning} className={styles.warningCloseBtn}>{tr("Понятно")}</button>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

/** Строка данных в модальном окне */
const ModalDataRow = ({ label, value, prefix }) => { useInterfaceLanguage(); return (<div className={styles[`${prefix}DataItem`]}>
    <span className={styles[`${prefix}Label`]}>{tr(label)}:</span>
    <span className={styles[`${prefix}Value`]}>{tr(value)}</span>
  </div>); };

export default React.memo(StatusModals);
